import * as _ from "lodash";

export class CssMapService {
    private static cssMap: any[] = [
        {
            module: "dashboard",
        css: [
          "Content/app/TalentPayroll/Timesheet/talentfinance-payroll.css",
                "Content/app/TalentPayroll/Dashboard/dashboard.css",
                "Content/app/TalentPayroll/Dashboard/onboarding.css",
                "Content/app/TalentPayroll/Dashboard/Reports/reports.css",
              "Content/app/TalentPayroll/Dashboard/studioexport.css",
              "Content/app/TalentPayroll/Timesheet/contact-flyout.css",
              "Content/app_bs5/areas/contacts/contacts.css",
            ],
        },
        {
            module: "contact",
            css: [
                "Content/app_bs5/areas/events/events.css",
                "Content/app_bs5/areas/contacts/contacts.css",
                "Content/ng-override/common/ng-tags-input.bootstrap.css",
            ],
        },
        {
            module: "template",
            css: [
                "Content/app_bs5/areas/admin/admin.min.css",
                "Content/app_bs5/css/dragula-dnd.css",
            ],
        },
        {
            module: "timesheet",
            css: [
                "Content/app/TalentPayroll/Dashboard/dashboard.css",
                "Content/app/TalentPayroll/Timesheet/talentfinance-payroll.css",
                "Content/app_bs5/areas/contacts/contacts.css",
                "Content/app/olympics/scorepay-olympics.css",
            ],
        },
        {
            module: "help",
            css: [
                "Content/app_bs5/areas/events/events.css",
                "Content/app/TalentPayroll/Timesheet/talentfinance-payroll.css",
                "Content/app_bs5/areas/contacts/contacts.css",
            ],
        },
    ];
    static get(module: string): any {
        return _.find(this.cssMap, (o) => {
            return o.module === module;
        });
    }
}
